import { useContext, useEffect, useMemo } from 'react';
import { AddressSelectionContext } from './AddressSelectionProvider';
import { AddressSelectionOrderData } from './types';
import { useRestaurants } from './useRestaurants';
import { useAddress } from './useAddress';
import dayjs from '../../utils/dayjs';
import { generatePreOrderTimesForWeek } from './components/restaurant-list/preOrderHelpers';
import { DeliveringRestaurantDto } from '@kotipizzagroup/kotipizza-shops-api-client';

export const useAddressSelectionData = (): AddressSelectionOrderData => {
  const address = useAddress();
  const { restaurants } = useRestaurants();

  const { orderType, restaurantId, isPreorder, preorderTime, setPreorderTime } =
    useContext(AddressSelectionContext);

  const selectedRestaurant = useMemo(() => {
    return restaurants.find((r) => r.restaurantId === restaurantId);
  }, [restaurants, restaurantId]);

  useEffect(() => {
    if (!preorderTime || !selectedRestaurant) return;

    const preorderTimes = generatePreOrderTimesForWeek([selectedRestaurant], orderType);
    if (!preorderTimes?.length) return;

    const isSelectedPreorderTimePossible = preorderTimes[0].isSameOrBefore(dayjs(preorderTime));

    if (!isSelectedPreorderTimePossible) {
      setPreorderTime(preorderTimes[0]);
    }
  }, [orderType, preorderTime, selectedRestaurant, setPreorderTime]);

  return {
    type: orderType,
    userAddress: address || null,
    restaurantId,
    restaurant: selectedRestaurant as DeliveringRestaurantDto,
    preorder: {
      isPreOrder: isPreorder,
      preorderTime,
    },
  };
};
